export default "__VITE_PUBLIC_ASSET__0e78ff94__"